












































































import { Component, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";

import AppVue from "@/AppVue.vue";
import { CriticalSkillModel, CapabilityRatingItemModel } from "@/core/models";

@Component
export default class CapabilityRatingsCpt extends AppVue {
  @Prop() model: CriticalSkillModel;
  @Prop() subStep: number;
  @Prop({ default: false }) disabled: boolean;

  unSelected(capabilities: CapabilityRatingItemModel[]) {
    return _.filter(capabilities, { isSelected: false });
  }

  selected(capabilities: CapabilityRatingItemModel[]) {
    return _(capabilities)
      .filter({ isSelected: true })
      .orderBy(["sortOrder"])
      .value();
  }

  addCapability(capability: CapabilityRatingItemModel) {
    capability.sortOrder = this.selected(this.model.capabilities).length + 1;
    capability.isSelected = true;
  }

  removeCapability(capability: CapabilityRatingItemModel) {
    delete capability.sortOrder;
    capability.isSelected = false;
  }

  moveUp(capability: CapabilityRatingItemModel) {
    this.swapCapabilities(capability, -1);
  }

  moveDown(capability: CapabilityRatingItemModel) {
    this.swapCapabilities(capability, 1);
  }

  private swapCapabilities(capability: CapabilityRatingItemModel, indexOffset: number) {
    const capabilities = this.selected(this.model.capabilities);

    if (!capability.sortOrder) {
      return;
    }

    const current = this.getCapability(capabilities, capability.sortOrder + indexOffset);
    if (!current || !current.sortOrder) {
      return;
    }

    capability.sortOrder += indexOffset;
    current.sortOrder -= indexOffset;

    this.$forceUpdate();
  }

  private getCapability(capabilities: CapabilityRatingItemModel[], sortIndex: number) {
    return _.find(capabilities, capability => {
      return capability.sortOrder === sortIndex;
    });
  }
}
